import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#i305404517__a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        stroke: "currentColor",
        d: "M10 .5c5.248 0 9.5 4.252 9.5 9.5s-4.252 9.5-9.5 9.5A9.498 9.498 0 0 1 .5 10C.5 4.752 4.752.5 10 .5Zm2.581 12.871c-.189 0-.373.047-.526.092-.08.023-.166.05-.25.076-.085.027-.172.054-.267.081a5.397 5.397 0 0 1-1.538.211c-.68 0-1.166-.105-1.538-.21l-.269-.082c-.083-.026-.169-.053-.249-.076a1.903 1.903 0 0 0-.525-.092c-1.7 0-3.08 1.381-3.08 3.08v.801l.203.15A9.164 9.164 0 0 0 10 19.21c2.044 0 3.93-.68 5.458-1.808l.203-.15v-.8c0-1.7-1.38-3.08-3.08-3.08ZM10 .79C4.921.79.79 4.921.79 10c0 2.407.935 4.59 2.447 6.23l.71.77.153-1.036a3.358 3.358 0 0 1 3.319-2.883c.322 0 .545.083.946.207.4.124.89.252 1.635.252.744 0 1.235-.128 1.636-.252.402-.124.625-.207.945-.207 1.692 0 3.08 1.25 3.32 2.883L16.052 17l.71-.77A9.164 9.164 0 0 0 19.21 10c0-5.079-4.131-9.21-9.21-9.21Zm0 4.227a3.048 3.048 0 1 1 0 6.096 3.048 3.048 0 0 1 0-6.096Zm0 .29a2.76 2.76 0 0 0-2.758 2.757A2.76 2.76 0 0 0 10 10.822a2.76 2.76 0 0 0 2.758-2.758A2.76 2.76 0 0 0 10 5.307Z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i305404517__a" }, [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }